import React from "react";
import MultiSelect, { MultiSelectProps } from "@/components/atoms/MultiSelect";
import { useTranslation } from "react-i18next";
import { enumToEntries } from "@/utils/enumToArray";
import OrderTypeEnum from "@/constants/enums/OrderTypeEnum";

/**
 * Order types the user may filter on. AUCTION is deliberately left out: this is a UI-only trim, the
 * API still returns auction orders and they still render in the table. Re-add OrderTypeEnum.AUCTION
 * here to bring the option back.
 */
const SELECTABLE_ORDER_TYPES: OrderTypeEnum[] = [OrderTypeEnum.BUY, OrderTypeEnum.SELL];

/**
 * MultiSelectOrderTypes component renders a MultiSelect dropdown for Order Types.
 * It automatically populates options from OrderTypeEnum and handles translations.
 */
export const MultiSelectOrderTypes: React.FC<MultiSelectProps> = ({ ...restProps }: MultiSelectProps) => {
  const { t } = useTranslation();

  const orderTypesList = enumToEntries(OrderTypeEnum).filter((entry) =>
    SELECTABLE_ORDER_TYPES.includes(entry.value as OrderTypeEnum)
  );

  const options = orderTypesList.map((entry) => ({
    value: entry.value.toString(),
    label: t(`enumerables:orderType.${entry.label}`),
  }));

  return (
    <MultiSelect label={t("orders:orderType")} data-testid="multi-select-order-types" data={options} {...restProps} />
  );
};

export default MultiSelectOrderTypes;
